import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { topics } from "@/mocks/topics";

const picks = topics.filter((topic) => topic.category === "recreate" || topic.category === "comment").slice(0, 4);

const ideas = [
  "把一句台词接成三集小短剧",
  "给老梗配上完全相反的背景音乐",
  "用方言重新配音一个名场面",
  "把评论区神评做成对话截屏排版",
];

export default function CreativeWall() {
  return (
    <section className="bg-secondary-50" aria-labelledby="creative-title">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)]">
          <Reveal>
            <div>
              <SectionHeading
                eyebrow="二创二改"
                title={<span id="creative-title">没有灵感？从这四条开始下手</span>}
                desc="二创不需要多高的技术，能接住梗的情绪就够了。下面这几种玩法门槛最低、最容易出圈。"
              />
              <ol className="mt-8 space-y-4">
                {ideas.map((idea, index) => (
                  <li key={idea} className="flex items-start gap-4">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-base text-foreground-950">
                      {index + 1}
                    </span>
                    <p className="pt-1 text-sm leading-relaxed text-foreground-700">{idea}</p>
                  </li>
                ))}
              </ol>
              <Link
                to="/topics?category=recreate"
                className="mt-8 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-600 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-secondary-700"
              >
                看更多二创案例
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </Reveal>

          <div className="flex flex-col gap-4">
            {picks.map((topic, index) => (
              <Reveal key={topic.id} delay={index * 70}>
                <article className="group flex items-center gap-4 rounded-lg border border-secondary-200 bg-background-50 p-4 transition-colors hover:border-secondary-400">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-2xl text-secondary-700">
                    <i className={index % 2 === 0 ? "ri-magic-line" : "ri-chat-smile-2-line"} aria-hidden="true"></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-base font-medium leading-snug text-foreground-950">
                      <Link to={`/topics/${topic.id}`} className="hover:text-secondary-700">
                        {topic.title}
                      </Link>
                    </h3>
                    <p className="mt-1 line-clamp-1 text-sm text-foreground-600">{topic.summary}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}